import {defineStore} from "pinia";
import router from "@/router/index.js";
import {getAuthenticatedRequest} from "@/stores/AuthenticatedRequest.js";
import {useUserStore} from '@/stores/user.js';
import {useApi} from "@/services/useApi.js";
import {client} from "@/stores/client.js";

export const useHotOrdersStore = defineStore('hotOrders', {
  state: () => ({
    activeOrders: [],
    applicants: [],
    selectedHotOrder: {},
    keyword: '',
    filter: {
      games: []
    },
  }),
  getters: {
    /*getOrders: state => type => state[`${type}Orders`],
    limitedOrders: (state) => {
      return (type, limit) => {
        const list = state[`${type}Orders`] || []
        return limit ? list.slice(0, limit) : list
      }
    },
    shopSummary(state) {
      return {
        price: 'price',
      }
    },*/
    getActiveOrderApplicants: (state) => {
      return (hotOrderID) => {
        return state.applicants.find(app => app.id === hotOrderID)['applicants']
      }
    },
    isFilterActive(state) {
      return state.filter.games.length > 0
    },
    activeFilterCount(state) {
      return state.filter.games.length
    },
    getFilteredActiveOrderIds() {
      return this.getActiveOrders.map(order => ({id: order.id}))
    },
    getActiveOrders(state) {
      const lowerKeyword = state.keyword.trim().toLowerCase();

      const filtered = state.activeOrders.filter(order => {
        const matchGame =
          state.filter.games.length === 0 || state.filter.games.includes(order.game);

        if (!lowerKeyword) return matchGame;

        const mainFields = [
          order.uuid,
          order.game,
          order.currency,
          order.description,
          order.title,
          order.notes,
          order.takerName
        ].some(field => field && field.toLowerCase().includes(lowerKeyword));

        const applicantMatch = order.applicants?.some(applicant => {
          return [
            applicant.discordDisplayName,
            applicant.discordUsername,
            applicant.name,
            applicant.username
          ].some(field => field && field.toLowerCase().includes(lowerKeyword));
        });

        return matchGame && (mainFields || applicantMatch);
      });

      return filtered.length ? filtered : [];
    }
  },
  actions: {
    async action_getActiveOrders() {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 10109,
      };

      return await useApi(
        request,
        (response) => {
          this.setActiveOrders(response.data.boostOrders)
          return {
            result: true,
            data: response.data.boostOrders
          };
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage || 'Handle Failure';
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_getTopRollsAccounts() {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 2072,
        "boostOrders": this.getFilteredActiveOrderIds
      };

      return await useApi(
        request,
        (response) => {
          this.setApplicants(response.data.boostOrders)
          return {
            result: true,
            data: response.data.boostOrders
          };
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage || 'Handle Failure';
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_assignTaker(type, payload) {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 2082,
        "boostOrder": {...payload},
      };

      //console.log(`action_updateHotOrder_${type}`, request);

      return await useApi(
        request,
        (response) => {
          //console.log(`✅ action_updateHotOrder_${type} Success`, response);
          return {
            result: true
          };
        },
        (errorMessage) => {
          //console.log('⚠️ Handle Credential Expired:', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          //console.log('❌ Handle Failure:', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_removeAllApplicants(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 2081,
        "boostOrder": {
          id: payload.id
        },
      };

      //console.log(`action_updateHotOrder_${type}`, request);

      return await useApi(
        request,
        (response) => {
          //console.log(`✅ action_updateHotOrder_${type} Success`, response);
          return {
            result: true
          };
        },
        (errorMessage) => {
          //console.log('⚠️ Handle Credential Expired:', errorMessage);
          return errorMessage;
        },
        (errorMessage) => {
          //console.log('❌ Handle Failure:', errorMessage);
          return errorMessage || 'Handle Failure';
        }
      );
    },
    async action_getAllUpdateDogs() {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 2092,
      };

      return await useApi(
        request,
        (response) => {
          return {
            result: true,
            data: response.data.boostOrder.updatedogs
          };
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage || 'Handle Failure';
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_updateUpdateDog(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 2094,
        "boostOrder": {
          "updatedog": {...payload}
        }
      };

      return await useApi(
        request,
        (response) => {
          return {
            result: true,
          };
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage || 'Handle Failure';
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    async action_addUpdateDog(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        "subRequest": 2093,
        "boostOrder": {
          "updatedog": {...payload}
        }
      };

      return await useApi(
        request,
        (response) => {
          return {
            result: true,
          };
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return errorMessage || 'Handle Failure';
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return errorMessage;
        }
      );
    },
    setActiveOrders(newOrders) {
      // If we don't have anything yet, set it up right away.
      if (!this.activeOrders.length) {
        this.activeOrders = newOrders
        return
      }

      // Delete orders that no longer exist.
      this.activeOrders = this.activeOrders.filter(order =>
        newOrders.some(newO => newO.id === order.id)
      )

      // Update or add orders
      newOrders.forEach(newO => {
        const existing = this.activeOrders.find(o => o.id === newO.id)
        if (existing) {
          // We only update fields that have changed.
          Object.assign(existing, newO)
        } else {
          this.activeOrders.push({...newO, applicants: []})
        }
      })
    },
    setApplicants(newApplicants) {
      this.applicants = newApplicants

      newApplicants.forEach(appOrder => {
        const order = this.activeOrders.find(o => o.id === appOrder.id)
        if (!order) return

        if (!order.applicants) order.applicants = []

        const newList = appOrder.applicants || []
        const currentList = order.applicants

        // 1️⃣ Delete applicants who are no longer there.
        for (let i = currentList.length - 1; i >= 0; i--) {
          const existing = currentList[i]
          if (!newList.some(n => n.id === existing.id)) {
            currentList.splice(i, 1) // Delete
          }
        }

        // 2️⃣ Update or add new applicants
        newList.forEach(newA => {
          const existing = currentList.find(a => a.id === newA.id)
          if (existing) {
            // Only fields that have changed are updated.
            Object.assign(existing, newA)
          } else {
            currentList.push({...newA})
          }
        })

        // If takerID exists, put it first, then the rest in descending order.
        const taker = order.takerID
          ? currentList.find(a => a.id === order.takerID)
          : null

        const others = currentList
          .filter(a => !taker || a.id !== taker.id)
          .sort((a, b) => (b.roll || 0) - (a.roll || 0))

        order.applicants.splice(0, order.applicants.length, ...(taker ? [taker, ...others] : others))
      })
    }
  },
  persist: {
    paths: ['filter'],
  },
})